import React, { useCallback } from 'react';

import { useTheme } from '@mui/material/styles';
import { PropTypes } from 'prop-types';

// Styles are defined as a plain function (not using makeStyles or sx)
// since this component renders outside the MUI ThemeProvider wrapper
const getStyles = theme => ({
  root: {
    display: 'flex',
    width: '100%',
    height: '100vh',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    color: theme.palette.common.white,
    fontSize: '32px',
    background: theme.palette.grey[900],
  },
  heading: {
    maxWidth: '600px',
    textAlign: 'center',
  },
});

const ErrorScreen = ({ message = null }) => {
  const theme = useTheme();

  const styles = getStyles(theme);
  const onBack = useCallback(() => {
    history.back();
  }, []);

  return (
    <div style={styles.root}>
      <img alt="" src="/assets/images/logos/lender_icon.svg" width="128" />
      <h1 style={styles.heading}>{message || `Oops... Something went wrong!`}</h1>
      <button onClick={onBack}>Back</button>
    </div>
  );
};

ErrorScreen.propTypes = {
  message: PropTypes.string,
};

export default ErrorScreen;
